import styled from 'styled-components';
import { PhotoCarouselDotsMixin } from '../../mixins/components/PhotoCarouselDotsMixin';
export var StyledPhotoCarouselDots = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPhotoCarouselDots",
  componentId: "c11n-8-111-1__sc-bi0wwg-0"
})(["", ""], PhotoCarouselDotsMixin);